import * as React from 'react';
import { CartMessagesProps } from '../../components/cart/cart-messages';

const CartMessagesView: React.StatelessComponent<CartMessagesProps> = props => {
    if (!props.shouldRender)
        return null;

    return (
        <>
            {
                props.maxReached ?
                    <p className="small">

                        {
                            props.performanceGroupId != null ?
                                props.text.maxPerformancesForGroupMessage.replace("{0}", props.groupName)
                                : props.text.maxPerformancesMessage
                        }
                    </p>
                    : null
            }

            {
                props.packageMin > 0 && props.cartPerformanceCount < props.packageMin ?
                    <p className="small">
                        {
                            props.performanceGroupId != null ?
                                props.text.addAdditionalPerformancesForPerformanceGroupMessage
                                    .replace("{0}", (props.packageMin - props.cartPerformanceCount).toString())
                                    .replace("{1}", props.groupName)
                                : props.text.addAdditionalPerformancesMessage
                                    .replace("{0}", (props.packageMin - props.cartPerformanceCount).toString())
                        }
                    </p>
                    : null
            }

            {
                props.processPackageErrorMessage.length > 0 ?
                    <p className="field-validation-error">
                        {props.processPackageErrorMessage}
                    </p>
                    : null
            }
        </>
    );
}

export default CartMessagesView;